/* Petal Post: optional "Arrangement style" choice (All round or Front facing) on products tagged pp-facing.
   A front facing arrangement is built to be seen from the front, so it looks fuller and larger.
   Saved on the order line as "Arrangement style" only when Front facing is chosen. */
(function () {
  var root = document.getElementById('petal-options');
  if (!root) return;
  var data;
  try { data = JSON.parse(root.querySelector('script[data-pp-data]').textContent); } catch (e) { return; }
  if ((data.tags || []).indexOf('pp-facing') === -1) return;
  if (document.getElementById('pp-facing-group')) return;
  var notes = document.getElementById('pp-notes');
  var anchor = notes && notes.closest('label');
  if (!anchor) return;
  anchor.insertAdjacentHTML('beforebegin',
    '<div class="pp-group" id="pp-facing-group"><span class="pp-label">Arrangement style</span>' +
    '<label class="pp-radio"><input type="radio" name="pp-facing" value="" checked> <span>All round (looks good from every side)</span></label>' +
    '<label class="pp-radio"><input type="radio" name="pp-facing" value="Front facing"> <span>Front facing (looks fuller and larger from the front)</span></label></div>');
  function choice() {
    var e = document.querySelector('input[name="pp-facing"]:checked');
    return e ? e.value : '';
  }
  var origFetch = window.fetch;
  window.fetch = function (u, o) {
    try {
      var url = typeof u === 'string' ? u : ((u && u.url) || '');
      if (url.indexOf('/cart/add') !== -1 && o && typeof o.body === 'string' && choice()) {
        var b = JSON.parse(o.body);
        if (b.items && b.items[0]) {
          b.items[0].properties = b.items[0].properties || {};
          b.items[0].properties['Arrangement style'] = choice();
          o = Object.assign({}, o, { body: JSON.stringify(b) });
        }
      }
    } catch (e) { /* send the original request */ }
    return origFetch.call(this, u, o);
  };
})();
